export default {
  name: 'Footer',
  data () {
    return {
      year: (new Date()).getFullYear()
    }
  },
}
